// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PStepBackwardOutlinedSvg from "@fishx/icons-svg/es/asn/PStepBackwardOutlined";
import FishxIcon from '../components/FishxIcon';

var PStepBackwardOutlined = function PStepBackwardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PStepBackwardOutlinedSvg
  }));
};

PStepBackwardOutlined.displayName = 'PStepBackwardOutlined';
export default React.forwardRef(PStepBackwardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PStepBackwardOutlined.js
// module id = 3658
// module chunks = 0